/* © 2014 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
	* Unauthorized copying of this file, via any medium is strictly prohibited
	* Proprietary and confidential
	* Written by Aetonix, June 19, 2014
	* For information or permission request, email info@aetonixsystems.com
	*/

var Model = require("../types/Model.js");

module.exports = Model({
	name: "surveysettings",
	init: init,
	listeners: listeners,
	refresh: refresh
});

function init() {
	this.push({
		autosurveys: []
	});
	this.refresh();
}

function listeners() {
	return {
		"mqtt:$/survey/setting/updated": this.push,
		"connectivity:online": refresh
	};
}

function refresh() {
	this.api.survey.settings()
		.then(handle_settings.bind(this));
}

function handle_settings(settings) {
	this.push(settings.survey);
}
